import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SHOW_CONSENT_CHECKBOX: `${cleanedFilename(__filename)}-show-consent-checkbox`,
};
